// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--IkycQ","Header":"Header--nKEu7","Content":"Content--3daid","ChildrenWrapper":"ChildrenWrapper--gtSxF","Branding":"Branding--2_J7Q","Footer":"Footer--lJrd6"};